


export const _newspath = 'https://raw.githubusercontent.com/fig-x/fig-x-data/main/news.json'
export const _peoplepath = 'https://raw.githubusercontent.com/fig-x/fig-x-data/main/people.json'
export const _publicationpath = 'https://raw.githubusercontent.com/fig-x/fig-x-data/main/publication.json'
export const _researchpath = 'https://raw.githubusercontent.com/fig-x/fig-x-data/main/research.json'
export const _artifactpath = 'https://raw.githubusercontent.com/fig-x/fig-x-data/main/artifact.json'



// export const _newspath = "http://localhost:8081/news.json"
// export const _peoplepath = 'http://localhost:8081/people.json'
// export const _peoplepath = '/people.json'
// export const _publicationpath = 'http://localhost:8081/publication.json'
// export const _researchpath = 'http://localhost:8081/research.json'
// // export const _artifactpath = 'http://localhost:8081/artifact.json'

